import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-truncated-result',
    templateUrl: './truncated-result.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TruncatedResultComponent {
  @Input() limit: number = null;
  @Input() detailText: string = null;
  @Output() detailClick = new EventEmitter<void>();

  onDetailClicked(): void {
    this.detailClick.emit();
  }
}
